/* Nav Menu label */
export const NAV = {
  ALL_CATEGORIES: 'All Categories',
  ALL: 'All',
  DEAL: 'Deals'
};

/* Sidebar Nav Menu */
export const SIDEBAR_CLOSE_BTN_ID = 'btn--close-sidebar';

/* Sub Nav Categories */
export const CatLabel = { [NAV.ALL]: NAV.ALL_CATEGORIES };
